<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3 translate>{{'Search' | MMSTranslate}}</h3>
    <app-ui-search type="BULK" [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)" searchURL="bulkIntimation/search"
      itemsPerPage='100'>
    </app-ui-search>
  </div>
  <div class="text-a-right">
    <button nz-button [nzType]="'primary'" nz-dropdown [nzDropdownMenu]="searchProposalDD" translate>
      <i nz-icon nzType="plus"  nzTheme="outline"></i> {{'New Bulk Upload' | MMSTranslate}}
    </button>
    <nz-dropdown-menu #searchProposalDD="nzDropdownMenu" id="select-option" class="m-r-10">
      <ul nz-menu id="upload-menu">
            <li nz-menu-item *ngFor="let bulkUploadOption of bulkUploadOptions;let i = index"
            (click)="NewBulkIntimation(bulkUploadOption.type)" >
              <span>{{i + 1}}. {{bulkUploadOption.type}}</span>
            </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>

<!-- <h3 class="heading" translate>Last 5 Intimations</h3> -->
<h3 class="heading" translate>{{'Latest Bulk Uploads' | MMSTranslate}}</h3>

<!-- Data -->
<nz-table *ngIf="dataSet && dataSet.length > 0" #intimationSearchTable [nzData]="dataSet" [nzSize]="'middle'" [nzScroll]="{ x: '500px'}">
  <thead>
    <tr>

      <th>Batch Id</th>
      <th>File Name</th>
      <th>Total Records</th>
      <!-- <th>Successful Records</th> -->
      <th>Batch Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of intimationSearchTable.data">
      <td>{{data.batchId}}</td>
      <!-- <td><a (click)="openTransactionDetails('bulkIntimation',data.guid)">{{data.filename}}</a></td>  User for double data entry-->
      <td>{{data.filename}}</td>
      <td>{{data.totalRecord }}</td>
      <!-- <td>{{data.failedRecord }}</td> -->
      <td>{{data.batchStatus | technicalTranslate}}</td>
      <td [class.anchors-are-disabled]="data.batchStatus=='PROCESSING'"><a (click)="viewBatchStatus(data.guid)">View Status</a> | <a (click)="processBatch(data.guid,data)">Process</a></td>
    </tr>
  </tbody>
</nz-table>
<app-generic-zero-ui [list]="dataSet" icon="file-search" 
[title]="bulkIntimationZeroState.title" [message]="bulkIntimationZeroState.message" [icon]="bulkIntimationZeroState.icon"></app-generic-zero-ui>


<nz-modal [(nzVisible)]="bulkStatusModal" nzTitle="Batch Details" nzWidth="80%"
    (nzOnCancel)="bulkStatusModal=false" (nzOnOk)="bulkStatusModal=false" nzOkText="OK">
    <ng-container *ngIf="bulkStatusModal">
      <nz-table #bulkDetailTable [nzData]="bulkStatusData" [nzShowPagination]="true" nzZIndex="100">
        <thead>
          <tr>
            <th translate>Proposal Num</th>
            <th translate>Intimation Num</th>
            <th translate>Insured Name</th>
            <th translate>Intimation Date</th>
            <th translate>Member Num</th>
            <th translate>Invalid Reason</th>
            <th translate>Status</th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of bulkDetailTable.data">
            <td>{{data?.proposalNum ? data?.proposalNum : '-'}}</td>
            <td>{{data?.intimationNum ? data?.intimationNum : '-' }}</td>
            <td>{{data?.insuredName  ? data?.insuredName  : '-'}}</td>
            <td>{{data?.intimationDt ? getLocalDateString(data.intimationDt) : '-' }}</td> 
            <td>{{data?.memberNum  ? data?.memberNum  : '-'}} </td>
            <td>{{data?.invalidReason  ? data?.invalidReason  : '-'}} </td>
            <td [ngClass]="{'col-green':data?.statusCd =='Success', 'col-red':data?.statusCd !='Success'}">{{(data?.statusCd | technicalTranslate ) || ''}}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
        
</nz-modal>
